<template>
  <div class="Modal_inner">
    <div class="LogRecord__modal">
      <div class="LogRecord__modal_fx LogRecord__modal--pt">
        <div class="LogRecord__modal_time">
          <div class="LogRecord__modal_time_top">
            <div class="LogRecord__modal_head_box">
              <div class="LogRecord__modal_head LogRecord__modal_head_line">
                <span class="LogRecord__modal_head_tx">MELONでの瞑想</span>
              </div>
              <div class="LogRecord__modal_head_side">
                <span class="LogRecord__modal_time_num ft_en">{{ meditationMelontv }}</span>
                <span class="LogRecord__modal_time_tx">分</span>
              </div>
            </div>
            <div class="LogRecord__modal_note">
              ※クラス受講・MELON TVの視聴時間
            </div>
            <div class="LogRecord__modal_note">
              - クラス受講の視聴時間
              <div v-for="log of listzoomlogs" :key="log.id">
                <span class="LogRecord__modal_head_tx">
                  {{ log.class_schedule ? formatZoomLogs(log) : '' }} :
                </span>
                <span class="LogRecord__modal_time_tx"> {{ log.class_schedule ? log.class_schedule.time : '' }}分</span>
              </div>
            </div>
            <div class="LogRecord__modal_note">
              - MELON TVの視聴時間
              <div v-for="log of listmelonlogs" :key="log.id">
                <span class="LogRecord__modal_head_tx">
                  {{ log.melon_tv ? formatMelonLogs(log) : '' }} :
                </span>
                <span class="LogRecord__modal_time_tx"> {{ log.watch_time }}分</span>
              </div>
            </div>
          </div>
          <div :class="`LogRecord__modal_time_bottom ${$v.timeMeditation.$invalid ? '_error' : ''}`">
            <div class="LogRecord__modal_head LogRecord__modal_head_line">
              <span class="LogRecord__modal_head_tx">個人の瞑想</span>
            </div>
            <div
              class="
                LogRecord__modal_head_side LogRecord__modal_head_side--vertical
              "
            >
              <input
                v-model.number="$v.timeMeditation.$model"
                class="LogRecord__modal_input LogRecord__modal_input--sm"
                type="text"
                required
                @keypress="onlyNumber"
              >
              <span
                class="LogRecord__modal_time_tx LogRecord__modal_tx--line"
              >分</span>
            </div>
          </div>
          <div class="Form__error_tx custom_error">
            <label v-if="!$v.timeMeditation.required">個人の瞑想時間入力してください</label>
            <label v-if="!$v.timeMeditation.maxValueValue">値は1440未満である必要があります</label>
            <label v-if="!$v.timeMeditation.minValueValue">値は0より大きくなければなりません</label>
          </div>
        </div>
        <div class="LogRecord__modal_memo">
          <div class="LogRecord__modal_head">
            ジャーナリング
          </div>
          <textarea
            v-model="diary"
            class="LogRecord__modal_input LogRecord__modal_input_memo"
          />
        </div>
      </div>
    </div>
    <div class="LogRecord__modal_btn_area">
      <button
        :disabled="$v.timeMeditation.$invalid"
        class="LogRecord__modal_btn ft_en _hover_pt01 _cross Border-none"
        @click="changeStep2"
      >
        OK
      </button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { minValue } from 'vuelidate/lib/validators'
import { maxValue } from 'vuelidate/lib/validators'
import checkNumber from '@/helpers/onlyNumber'
import moment from 'moment'

const validations = {
  timeMeditation: {
    required,
    maxValueValue: maxValue(1440),
    minValueValue: minValue(0)
  },
  meditationMelontv: {
    required,
    maxValueValue: maxValue(1440),
    minValueValue: minValue(0)
  }
}
export default {
  name: 'LogWriteModalStep2',
  mixins: [validationMixin],
  props: {
    detailStep2: {
      type: Object,
      default: function() {
        return null
      }
    },
    listzoomlogs: {
      type: Array,
      default: () => []
    },
    listmelonlogs: {
      type: Array,
      default: () => []
    },
    meditationMelontv: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      timeMeditation: null,
      diary: null
    }
  },
  watch: {
    detailStep2: {
      handler() {
        this.setDefault()
      }
    }
  },
  methods: {
    formatZoomLogs(log) {
      return moment(log.class_schedule.date).local().format('HH:mm~ ') + log.class_schedule.class + ' by ' + log.class_schedule.master_instructor.name
    },
    formatMelonLogs(log) {
      return moment(log.melon_tv.date).local().format('YYYY-MM-DD HH:mm~ ') + log.melon_tv.title + ' by ' + log.melon_tv.master_instructor.name
    },
    changeStep2() {
      this.$emit('changeStep2', 3, this.timeMeditation, this.diary)
    },
    setDefault() {
      this.timeMeditation = this.detailStep2.meditation_time
      this.diary = this.detailStep2.diary
    },
    onlyNumber($event) {
      checkNumber.onlyNumber($event)
    }
  },
  validations: validations
}
</script>
